import Home from '@/pages/home'
import Error404 from '@/pages/error/404'
import Design from '@/pages/goods/design'
import Helper from '@/pages/goods/helper'
import shopMall from '@/pages/goods/shopMall'
import contactUs from '@/pages/us/contactUs'

import businessCard from '@/pages/goods/businessCard'
export const routes = [{
  path: '/',
  name: 'home',
  redirect: '/home',
  component: Home
},
{
  path: '/home',
  name: 'home',
  component: Home

},

{
  path: '/design', // 设计中台
  name: 'design',
  component: Design
},
{
  path: '/contactUs', // 联系我们
  name: 'contactUs',
  component: contactUs
},

{
  path: '/businessCard', // 数字名片
  name: 'businessCard',
  component: businessCard
},
{
  path: '/helper', // 数字助手
  name: 'helper',
  component: Helper

},
{
  path: '/shopMall', // 门店商城
  name: 'shopMall',
  component: shopMall

},

{
  path: '/404',
  name: '404',
  component: Error404
}, {
  path: '/*',
  name: 'page404',
  component: Error404
}
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/routers.js